import { WmsService } from '../resource'
import { activeParam, parseToggleResponse, badToggleResponseError, ACTIVE_ON, ACTIVE_ALL } from '../utils/wmsProductActive'

const  WmsProductModule = {
  namespaced: true,
  state: {
    // active products only — the list every picker / packing page reads (getData)
    data: [],
    // active=all — history / report filters that must still name disabled products (#416 F5)
    data_all: [],
	data_wait_ship :[],
	data_inventory_summary :[],
	data_forecast: []
  },
  mutations: {
    SET_DATA (state, data) {
      state.data = data
    },
	SET_DATA_ALL (state, data) {
		state.data_all = data
	},
	// #416 F2: a toggle on /wms/product reaches pickers that are kept alive
	// (taskbar) without a refetch: a disabled product leaves `data`.
	APPLY_ACTIVE (state, { id, is_active, row }) {
		// a state built without data_all (older module state / test store) must not
		// turn a successful toggle into an error
		const same = (r) => r && String(r.ID) === String(id)
		const data = Array.isArray(state.data) ? state.data : []
		if (Number(is_active) === 0) {
			state.data = data.filter((r) => !same(r))
		} else if (row && !data.some(same)) {
			state.data = data.concat([Object.assign({}, row, { is_active: 1 })])
		}
		;(Array.isArray(state.data_all) ? state.data_all : []).forEach((r) => { if (same(r)) r.is_active = Number(is_active) === 0 ? 0 : 1 })
	},
	SET_DATA_WAIT_SHIP (state, data) {
		state.data_wait_ship = data
	},
	SET_DATA_INVENTORY (state, data) {
		state.data_inventory_summary = data
	},
	SET_DATA_FORECAST (state, data) {
		state.data_forecast = data
	},
  },
  actions: {
    createData ({ commit, state }, data) {
        return WmsService.ProductCreate(data)
    },
    updateData ({ commit, state }, data) {
        return WmsService.ProductUpdate(data.id,data.payload)
    },
    deleteData ({ commit, state }, data) {
        return WmsService.ProductDelete(data)
    },
	getBarcode ({ commit, state }, data) {
        return WmsService.ProductGetBarcode(data)
    },
	async listWmsInventorySummary({ commit, state }, data) {
		try{
			const resp = await WmsService.WmsInventorySummary()
			  commit('SET_DATA_INVENTORY', resp.data== null ? [] : resp.data)
		  }
		  catch(err)
		  {
			commit('SET_DATA_INVENTORY', [])
		  }
	},
    // #416 F1: params.active = 1 | 0 | "all" (default 1, the BE default). Only the
    // active list is shared (getData); "all" fills getDataAll; "0" is returned
    // to the caller only (/wms/product), so a filter there never leaks disabled
    // products into a kept-alive picker. Resolves to the rows.
    async listData ({ commit, state }, params) {
      const active = activeParam(params && typeof params === 'object' ? params.active : undefined)
      const target = active === ACTIVE_ON ? 'SET_DATA' : active === ACTIVE_ALL ? 'SET_DATA_ALL' : null
      try{
        const data = await WmsService.ProductList({ active })
        const rows = data.data.Data == null ? [] : data.data.Data
        if (target) commit(target, rows)
        return rows
      }
      catch(err)
      {
        if (target) commit(target, [])
        return []
      }
    },
    // #416 F2: POST /wms/product/:id/active. Rejects with the axios error, or with
    // badToggleResponseError() when a 2xx body has no is_active (nothing committed).
    async setActive ({ commit }, { id, is_active, row }) {
      const resp = await WmsService.ProductSetActive(id, { is_active: is_active ? 1 : 0 })
      const result = parseToggleResponse(resp)
      if (!result) throw badToggleResponseError()
      commit('APPLY_ACTIVE', { id, is_active: result.is_active, row })
      return result
    },
	async listWaitShipData({commit,state},params) {
		try {
			const data = await WmsService.ProductWaitShipList(params)
			if (data.data.Data == null)
			{
			commit('SET_DATA_WAIT_SHIP', [])
			}
			else
			{
			commit('SET_DATA_WAIT_SHIP', data.data.Data)
			}

		}
		catch(err)
		{
			commit('SET_DATA_WAIT_SHIP', [])
		}

	},

	// V3 Stock Sync Actions
	async listDataV3 ({ commit, state }) {
		try{
			const data = await WmsService.ProductListV3()
			if (data.data.Data == null)
			{
				commit('SET_DATA', [])
			}
			else
			{
				commit('SET_DATA', data.data.Data)
			}
		}
		catch(err)
		{
			commit('SET_DATA', [])
		}
	},
	toggleStockSync({ commit, state }, data) {
		return WmsService.ProductStockSyncToggle(data.id, data.payload);
	},
	toggleStockAlarm({ commit, state }, data) {
		return WmsService.ProductStockAlarmToggle(data.id, data.payload);
	},
	updateStockSettings({ commit, state }, data) {
		return WmsService.ProductStockSettings(data.id, data.payload);
	},
	async listForecast ({ commit, state }) {
		try{
			const data = await WmsService.ProductForecast()
			if (data.data.Data == null)
			{
				commit('SET_DATA_FORECAST', [])
			}
			else
			{
				commit('SET_DATA_FORECAST', data.data.Data)
			}
		}
		catch(err)
		{
			commit('SET_DATA_FORECAST', [])
		}
	},
	// Returns the raw axios response so the page can read the meta block
	// (date_from / date_to / total_orders) alongside the items array.
	listUsage ({ commit, state }, params) {
		return WmsService.ProductUsage(params);
	},
  },
  getters: {
    getData (state) {
      return state.data
    },
	getDataWithAll (state) {
		return  [
			{ID:0,Name:"--- สินค้า --- "},...state.data ];
	  },
	getDataAll (state) {
		return state.data_all
	},
	getDataAllWithAll (state) {
		return  [
			{ID:0,Name:"--- สินค้า --- "},...state.data_all ];
	},
	getDataWaitShip (state) {
		return state.data_wait_ship
	},
	getInventortySummary (state) {
		return state.data_inventory_summary
	},
	getDataForecast (state) {
		return state.data_forecast
	},
  }
}

export default WmsProductModule
